const { createProxyMiddleware } = require("http-proxy-middleware");
module.exports = function (app) {
  app.use(
    createProxyMiddleware("/api", {
      // target: "https://admin.cochat.lenovo.com/api", // 目标路径
      target: "https://uat.cochat.lenovo.com/admin-cochat/api", // 目标路径
      changeOrigin: true,
      pathRewrite: {
        "^/api": "",
      },
    })
  );
};
